import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateWorkerConvictionDetailsRequest extends BaseUpdateRequest {
    isUnspentConvictions = false;
    convictionDetails = '';
}